/**
 * Main App Component
 */

import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Sidebar from './components/Sidebar';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import BookingCalendar from './components/BookingCalendar';
import MyBookings from './components/MyBookings';
import OwnerDashboard from './components/OwnerDashboard';
import FAQ from './components/FAQ';
import PartnerTermin from './components/partner/PartnerTermin';
import PartnerEinschulungen from './components/partner/PartnerEinschulungen';
import PartnerProfil from './components/partner/PartnerProfil';
import { settingsAPI } from './services/api';
import './App.css';

const AppLayout = ({ children }) => {
  useEffect(() => {
    settingsAPI.getPublicSettings().then(res => {
      const url = res.data?.favicon_url;
      if (url) {
        const link = document.querySelector("link[rel~='icon']");
        if (link) link.href = url;
      }
    }).catch(() => {});
  }, []);

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route
              path="/"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <BookingCalendar />
                  </AppLayout>
                </PrivateRoute>
              }
            />

            <Route
              path="/my-bookings"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <MyBookings />
                  </AppLayout>
                </PrivateRoute>
              }
            />

            <Route
              path="/faq"
              element={
                <PrivateRoute>
                  <AppLayout>
                    <FAQ />
                  </AppLayout>
                </PrivateRoute>
              }
            />

            {/* Partnerbereich (Physios) */}
            <Route
              path="/partner"
              element={
                <PrivateRoute partnerOnly={true}>
                  <AppLayout>
                    <PartnerTermin />
                  </AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/partner/einschulungen"
              element={
                <PrivateRoute partnerOnly={true}>
                  <AppLayout>
                    <PartnerEinschulungen />
                  </AppLayout>
                </PrivateRoute>
              }
            />
            <Route
              path="/partner/profil"
              element={
                <PrivateRoute partnerOnly={true}>
                  <AppLayout>
                    <PartnerProfil />
                  </AppLayout>
                </PrivateRoute>
              }
            />

            <Route
              path="/owner/*"
              element={
                <PrivateRoute ownerOnly={true}>
                  <AppLayout>
                    <OwnerDashboard />
                  </AppLayout>
                </PrivateRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
